module.exports = __webpack_public_path__ + "static/media/img_1.36b3e63a.png";